import endOfMonth from 'date-fns/endOfMonth';

export const getLeftPositionInPercentage = (activeMonths: Date[], date: Date) => {
  const firstDateTime = activeMonths[0].getTime();
  const lastDateTime = endOfMonth(activeMonths[activeMonths.length - 1]).getTime();

  return ((date.getTime() - firstDateTime) / (lastDateTime - firstDateTime)) * 100;
};
